import React from 'react';

const InputFormatSelector = ({ onFormatChange, activeFormat }) => {
  const formats = [
    { id: 'json', name: 'JSON', icon: '{}' },
    { id: 'natural', name: 'Natural', icon: '📝' },
    { id: 'visual', name: 'Visual', icon: '📷' }
  ];

  return (
    <div className="mb-10">
      <div className="flex gap-2 bg-gray-100/50 dark:bg-gray-800/50 p-1.5 rounded-2xl backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50">
        {formats.map((format) => (
          <button
            key={format.id}
            onClick={() => onFormatChange(format.id)}
            className={`flex-1 px-6 py-3.5 font-semibold text-sm transition-all duration-200 relative rounded-xl ${
              activeFormat === format.id
                ? 'bg-white dark:bg-gray-700 text-primary shadow-lg scale-[1.02]'
                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-white/50 dark:hover:bg-gray-700/50'
            }`}
          >
            <span className="mr-2 text-base">{format.icon}</span>
            {format.name}
            {activeFormat === format.id && (
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-gradient-to-r from-primary to-purple-600 rounded-full"></div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default InputFormatSelector;
